import { Paper, Typography } from '@mui/material';
import type { StateMdResponse } from '../../types/agents';
import { MarkdownView } from './MarkdownView';

interface StateMdViewerProps {
  stateMd: StateMdResponse | null;
}

export function StateMdViewer({ stateMd }: StateMdViewerProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }} data-testid="agents-state-md">
      <Typography variant="h6" gutterBottom>
        state.md
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        {stateMd?.last_edit
          ? `Last edited ${new Date(stateMd.last_edit).toLocaleString()}`
          : 'Last edit time unknown'}
      </Typography>
      {stateMd?.body ? (
        <MarkdownView body={stateMd.body} maxHeight={600} />
      ) : (
        <Typography variant="body2" color="text.secondary">
          No content loaded.
        </Typography>
      )}
    </Paper>
  );
}
